import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { AlertTriangle, LogOut, Siren, Eye } from 'lucide-react';

// Liste des candidats en difficulté / alerte (portails entreprise / financeur)
export const CandidatsDifficulteDialog = ({ open, onClose, alertes, onOpenCandidat }) => (
  <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="difficulte-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2 text-red-800"><AlertTriangle className="w-5 h-5" /> Candidats en difficulté ({alertes.length})</DialogTitle>
        <p className="text-sm text-slate-500">Candidats signalés en difficulté par le formateur, avec alerte ou en abandon. Cliquez pour ouvrir la fiche.</p>
      </DialogHeader>
      {alertes.length === 0 ? <p className="text-sm text-slate-400 py-6 text-center">Aucun candidat en difficulté.</p> : (
        <ul className="divide-y divide-slate-100 rounded-lg border border-slate-200">
          {alertes.map(a => (
            <li key={`${a.candidat_id}-${a.dossier_id}`}>
              <button type="button" onClick={() => { onOpenCandidat(a.candidat_id, a.dossier_id); onClose(); }} className="w-full text-left px-4 py-3 flex items-center justify-between gap-3 hover:bg-red-50/60 transition-colors" data-testid={`difficulte-candidat-${a.candidat_id}`}>
                <div className="min-w-0">
                  <p className="text-sm font-medium text-slate-900">{a.nom} {a.prenom} <span className="text-xs font-mono text-slate-400 ml-1">{a.dossier_code}</span>{a.entreprise_finale && <span className="text-xs text-cyan-700 ml-2">{a.entreprise_finale}</span>}</p>
                  <p className="text-xs text-slate-500 flex flex-wrap gap-2 mt-0.5">
                    {a.en_difficulte && <span className="inline-flex items-center gap-1 text-red-600"><AlertTriangle className="w-3 h-3" /> En difficulté</span>}
                    {a.nb_alertes_formateur > 0 && <span className="inline-flex items-center gap-1 text-orange-700"><Siren className="w-3 h-3" /> {a.nb_alertes_formateur > 1 ? `${a.nb_alertes_formateur} alertes` : `Alerte ${a.derniere_alerte?.type_label || ''}`}</span>}
                    {a.abandon && <span className="inline-flex items-center gap-1 text-slate-600"><LogOut className="w-3 h-3" /> Abandon</span>}
                    <span>{a.nb_absences} absence(s) · {a.nb_retards} retard(s)</span>
                  </p>
                </div>
                <Eye className="w-4 h-4 text-cyan-700 shrink-0" />
              </button>
            </li>
          ))}
        </ul>
      )}
    </DialogContent>
  </Dialog>
);
